module.exports = __webpack_public_path__ + "static/media/video_files.729db24e.svg";